<ion-action-sheet
  [isOpen]="isOpen"
  header="Add Vehicle"
  i18n-header
  [buttons]="addVehicleOptions()"
  (didDismiss)="addVehicleAction($event)"
></ion-action-sheet>
